import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: { user: null, isGuest: false },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      state.isGuest = false;
    },
    logout: (state) => {
      state.user = null;
      state.isGuest = false;
    },
    guestCheckout: (state) => {
      state.isGuest = true;
    },
  },
});

export const { login, logout, guestCheckout } = authSlice.actions;
export default authSlice.reducer;
